export function trackVariableDragOutside(
    editor: HTMLElement,
    onDropOutside: () => void,
): () => void {
    const ownerDocument = editor.ownerDocument;

    function isRemovalTarget(target: EventTarget | null): boolean {
        return (
            target instanceof Element &&
            !editor.contains(target) &&
            target.closest(
                'input, textarea, [role="textbox"], [contenteditable]:not([contenteditable="false"])',
            ) === null
        );
    }

    function handleDragOver(event: DragEvent) {
        if (!isRemovalTarget(event.target)) {
            return;
        }
        event.preventDefault();
        if (event.dataTransfer) {
            event.dataTransfer.dropEffect = 'move';
        }
    }

    function stopTracking() {
        ownerDocument.removeEventListener('dragover', handleDragOver, true);
        ownerDocument.removeEventListener('drop', handleDrop, true);
        ownerDocument.removeEventListener('dragend', stopTracking, true);
    }

    function handleDrop(event: DragEvent) {
        stopTracking();
        if (!isRemovalTarget(event.target)) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        onDropOutside();
    }

    // Accept an outside drop, but leave other editors' copy/move behavior
    // intact. Cancellation only ends tracking; it never removes the pill.
    ownerDocument.addEventListener('dragover', handleDragOver, true);
    ownerDocument.addEventListener('drop', handleDrop, true);
    ownerDocument.addEventListener('dragend', stopTracking, true);
    return stopTracking;
}
